import React from 'react';
import { TypedMemo } from '../common/types';
import { DemoArtistNoticeBody, DemoArtistNoticeProps } from './DemoArtistNoticeBody';
import { useIsDemoAccount } from './useIsDemoAccount';

/**
 * design: music24-demo-artist a2. The shell mounts this once for every page. It renders nothing
 * unless the read-only demo artist is active, so a normal session pays only for one selector.
 */
const DemoArtistNoticeComponent: React.FC<DemoArtistNoticeProps> = ({ className }) => {
  const isDemo = useIsDemoAccount();
  if (!isDemo) {
    return null;
  }
  return <DemoArtistNoticeBody className={className} />;
};

export const DemoArtistNotice = TypedMemo(DemoArtistNoticeComponent);
